import { useQuery } from "@tanstack/react-query";

import { apiGet } from "../api/client";
import type { LegacyMatch, PlayerSummary } from "../api/legacyTypes";
import { entitySlug } from "../utils/slug";

export function usePlayerSummaries(wiki: string, matches: LegacyMatch[], additionalNames: string[] = []) {
  const supportsIndividuals = wiki === "trackmania" || wiki === "chess" || wiki === "ageofempires" || wiki === "osu";
  const ids = supportsIndividuals
    ? [...new Set([...additionalNames, ...matches.flatMap((match) => [
        wiki === "trackmania" || !match.teamId1 ? match.participant1 : "",
        wiki === "trackmania" || !match.teamId2 ? match.participant2 : "",
        wiki === "trackmania" ? match.participant3 : "",
        wiki === "trackmania" ? match.participant4 : "",
      ])]
      .filter(Boolean)
      .map((name) => `${wiki}/${entitySlug(name)}`))].sort()
    : [];

  return useQuery({
    queryKey: ["player-summaries", wiki, ids.join(",")],
    queryFn: ({ signal }) => apiGet<Record<string, PlayerSummary>>(`/api/player-summaries?ids=${encodeURIComponent(ids.join(","))}`, signal),
    enabled: ids.length > 0,
    staleTime: 5 * 60_000,
  });
}
